export default __webpack_public_path__ + "static/media/hotel-room-2.2b8ece70.jpg";